import React, { useState } from 'react'

import { ChevronDownIcon } from '~/client/src/shared/components/icons/ChevronDownIcon'

interface IPropertyAccordionProps {
  title: string
  isDefaultExpanded?: boolean
  children: React.ReactNode
}

const PropertyAccordion: React.FC<IPropertyAccordionProps> = ({
  title,
  isDefaultExpanded = true,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded)

  return (
    <div>
      <button
        type="button"
        className="tw:flex tw:items-center tw:gap-2 tw:w-full tw:h-10 tw:px-3 tw:bg-muted tw:border-0 tw:border-y tw:border-solid tw:border-border tw:cursor-pointer"
        onClick={() => setIsExpanded(prev => !prev)}
      >
        <ChevronDownIcon
          size="sm"
          className={`tw:text-muted-foreground tw:transition-transform tw:duration-200 ${
            isExpanded ? '' : 'tw:-rotate-90'
          }`}
        />
        <span className="tw:text-title-sm tw:text-muted-foreground">
          {title}
        </span>
      </button>

      {isExpanded && <div>{children}</div>}
    </div>
  )
}

export default PropertyAccordion
